import { useCallback, useMemo } from 'react';

export const useAbsoluteLimitOfInvestment = ({
  limitOfInvestment,
  freeMargin,
  store,
}) => {
  const onChange = useCallback(
    (value) => {
      const newLimitOfInvestment = value / freeMargin;
      if (
        newLimitOfInvestment <= 1 &&
        newLimitOfInvestment >= limitOfInvestment.min
      ) {
        store.setLimitOfInvestment(newLimitOfInvestment);
      }

      if (newLimitOfInvestment > 1) store.setLimitOfInvestment(1);

      if (newLimitOfInvestment < limitOfInvestment.min)
        store.setLimitOfInvestment(limitOfInvestment.min);
    },
    [freeMargin, limitOfInvestment.min, store]
  );

  const value = useMemo(() => {
    const result = limitOfInvestment.value * freeMargin;
    if (result < 0) {
      return 0;
    }
    return result;
  }, [limitOfInvestment.value, freeMargin]);

  const min = useMemo(() => {
    return limitOfInvestment.min * freeMargin;
  }, [freeMargin, limitOfInvestment.min]);

  const max = useMemo(() => {
    return freeMargin;
  }, [freeMargin]);

  return {
    onChange,
    value,
    min,
    max,
  };
};
